import { ComponentProps } from "."
import { ModalContent, ModalTitle } from "./styled"

const Overrides = ({ children }: ComponentProps) => (
  <ModalContent>
    <ModalTitle>{"Review"}</ModalTitle>

    {children}
  </ModalContent>
)
export default Overrides
